import { buildMaybePartnerRoute } from '../../helpers/builders.js';
import { PortalRouteName } from './model.js';

const portalItineraryRoute = (itineraryID, locationData) => buildMaybePartnerRoute({
    ...locationData,
    name: PortalRouteName.ITINERARY,
    params: {
        ...locationData === null || locationData === void 0 ? void 0 : locationData.params,
        itineraryID,
    },
});
const portalAssignRoute = (shiftID, locationData) => buildMaybePartnerRoute({
    ...locationData,
    name: PortalRouteName.JOB_DETAILS,
    params: {
        ...locationData === null || locationData === void 0 ? void 0 : locationData.params,
        shiftID,
    },
});
const portalJobsRoute = (locationData) => buildMaybePartnerRoute({
    ...locationData,
    name: PortalRouteName.JOBS,
});
const portalOrdersRoute = (locationData) => buildMaybePartnerRoute({
    ...locationData,
    name: PortalRouteName.ORDERS,
});
const portalProcedureRoute = (procedureID, view = null, locationData) => buildMaybePartnerRoute({
    ...locationData,
    name: PortalRouteName.PROCEDURE,
    params: {
        ...locationData === null || locationData === void 0 ? void 0 : locationData.params,
        procedureID,
        view,
    },
});

export { portalAssignRoute, portalItineraryRoute, portalJobsRoute, portalOrdersRoute, portalProcedureRoute };
